<script setup lang="ts">
import { myRequest } from '@/utils/fetch'
import { ref } from 'vue'
import FAQ from '@/components/FAQ.vue'
import OGHeader from '@/components/OGHeader.vue'
const text = ref('')
const submitting = ref(false)
const submitted = ref(false)

const submit = async () => {
  submitting.value = true
  await myRequest('POST', '/app/support', { text: text.value })
  submitting.value = false
  submitted.value = true
}
</script>

<template>
  <OGHeader title="Support Center" subtitle="Get help or submit feedback" />

  <div class="row q-col-gutter-md full-width q-mb-md">
    <div class="col-12 col-md paddingFixerSingle">
      <div class="myCard q-pa-md full-height">
        <h6>What can we help you with?</h6>
        <div v-if="!submitted">
          <div class="text-caption text-grey-6">Feel free to suggest a feature, or give us any feedback you have!</div>
          <q-input label="Describe your issue" v-model="text" outlined type="textarea" class="q-mt-md" /><br />
          <q-btn
            @click="submit"
            class="full-width"
            color="secondary"
            :loading="submitting"
            :disable="submitting || !text.trim()"
            >Submit Ticket</q-btn
          >
          <div class="text-caption text-grey-6 q-mt-md">
            We will get back to you via email as soon as possible. Please allow for 24 hours.
          </div>
        </div>
        <div v-else>
          <p>
            Thank you for reaching out! We will get back to you via email as soon as possible. Please allow for 24
            hours.
          </p>
        </div>
      </div>
    </div>
    <div class="col-12 col-md paddingFixerSingle">
      <FAQ />
    </div>
  </div>
</template>
